export interface GTMPush {
  event: string
  [key: string]: any
}

export function addMatomoEvent(eventData: GTMPush) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(eventData)
}
